import React, { useCallback, useContext } from "react";

// Services
import { getScoreCV } from "../services/Patient";

// Context
import ScoresContext from "../context/ScoresContext";

// Interfaces
import { Parameter } from "../interfaces/Profile";
import { DataElement } from "../interfaces/PhysiologicalMonitoring";

const useCVTable = () => {

    const { scores } = useContext(ScoresContext);

    const getCVScoreValue = useCallback((sheetParamID: string, value: number | null) => {
        const scoreCVParameters = scores?.find(sc => sc.id === 1)?.score_parameters;
        const scoreParam = scoreCVParameters?.find(score => score.sheet_parameter_id === sheetParamID);
        if (scoreParam) return getScoreCV(value, scoreParam);
        return 0;
    }, [scores]);


    const getClassMaxMin = useCallback((value: number | null, param: Parameter) => {
        if (value === null) return {};
        if (param.max_limit !== null && param.max_limit !== undefined) {
            if (value > param.max_limit) return { fontWeight: 700, color: 'red' };
        }
        if (param.min_limit !== null && param.min_limit !== undefined) {
            if (value < param.min_limit) return { fontWeight: 700, color: 'blue' };
        }
        return {};
    }, []);

    const getStylesCV = useCallback((data: DataElement, param: Parameter): React.CSSProperties => {

        const id = param.id;
        if (id === undefined) return {};
        const userValue = data.values[id + '_user'] ?? null;
        return {
            ...userValue !== null && data.values[id] !== null ?
                { backgroundColor: 'var(--primary-color-lighter)' } : {},
            ...getClassMaxMin(data.values[id], param)
        }

    }, [getClassMaxMin]);

    return { getStylesCV, getCVScoreValue };

};

export default useCVTable;
